<template>
    <div>
        <div class="content__top">
            <div class="content__title">{{ Lang.get('js.shopping_cart') }}</div>
        </div>
        <div class="content__block">
            <div class="shopping-cart">
                <table class="table shopping-cart__table">
                    <thead>
                    <tr class="table__title">
                        <th><span>{{ Lang.get('js.product') }}</span></th>
                        <th></th>
                        <th><span>{{ Lang.get('js.price') }}</span></th>
                        <th><span>{{ Lang.get('js.qty') }}</span></th>
                        <th><span>{{ Lang.get('js.subtotal') }}</span></th>
                        <th><span>{{ Lang.get('js.remove') }}</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items" class="cart-item">
                        <td>
                            <img :src="item.image" alt="">
                        </td>
                        <td>
                            <a class="cart-item-link" :href="item.url"
                               :title="item.name"><span>{{ item.name }}</span></a>
                        </td>
                        <td>
                            <span class="table__price">
                                {{ item.price }}
                            </span>
                        </td>
                        <td>
                            <number-input
                                v-model="item.quantity"
                                :min="1"
                                size="small"
                                inline
                                center
                                controls
                                @change="changeQuantity(item)"
                            ></number-input>
                        </td>
                        <td>
                            <span class="table__price table__price_red">
                                {{ item.subtotal }}
                            </span>
                        </td>
                        <td>
                            <div class="table__remove">
                                <svg class="svg-icon" @click="removeItem(item.id)">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#remove"></use>
                                </svg>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="shopping-cart__box shopping-cart__box_mobile" v-if="showBonusItems">
                    <div class="shopping-cart__head">{{ Lang.get('js.select_free_bonus') }}</div>
                    <div class="shopping-cart__main">
                        <div class="bonus_selector shopping-cart__bonus">
                            <div>
                                <label v-for="(bonusItem, index) in bonusItems">
                                    <input v-model="selectedBonusItem"
                                           @change="setBonusItem"
                                           type="radio"
                                           name="inlineRadioOptions"
                                           :value="index">
                                    {{ bonusItem.title }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="shopping-cart__box">
                    <div class="shopping-cart__head">{{ Lang.get('js.select_shipping') }}</div>
                    <div class="shopping-cart__main">
                        <div class="shopping-cart__row radio-btn" v-for="(item, index) in shipping">
                            <input v-model="selectedShipping"
                                   class="form-check-input"
                                   type="radio"
                                   :id="item.name"
                                   name="shipping"
                                   :value=index
                            >
                            <label class="radio-btn__label" :for="item.name">
                                    <span class="radio-btn__circle">
                                        <svg class="svg-icon">
                                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#circle"></use>
                                        </svg>
                                    </span>
                                <div class="radio-btn__text">
                                    <div class="radio-btn__title">{{ item.name }} -
                                        <span v-if="totalPriceWithDiscount > item.min_free_cost"
                                              class="btn__color-inner">{{ Lang.get('js.free') }}</span>
                                        <span v-else class="btn__color-inner">{{ item.cost }}</span>
                                    </div>
                                    <p class="radio-btn__descriptions">
                                        {{ Lang.get('js.shipping.' + item.description) }}<br>
                                        <span class="radio-btn__color">{{
                                                Lang.get('js.shipping.free', {
                                                    'name': item.name,
                                                    'cost': item.min_free_currency_cost
                                                })
                                            }}</span>
                                    </p>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="shopping-cart__box">
                    <div class="shopping-cart__bottom">
                        <div class="shopping-cart__add-checkbox">
                            <div class="checkbox-holder">
                                <label class="text" for="add-checkbox">
                                    <input v-model="deliveryInsurance"
                                           id="add-checkbox"
                                           type="checkbox"
                                           :value="deliveryInsuranceCost"
                                    >
                                    <span class="state"></span>
                                    <span class="text">
                                        {{ Lang.get('js.delivery_insurance', { 'cost': deliveryInsuranceCost }) }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="shopping-cart__box shopping-cart__box_line" v-if="!showDiscount">
                    <div class="shopping-cart__head">{{ Lang.get('js.coupon_code') }}:</div>
                </div>

                <div class="shopping-cart__box">
                    <div class="coupon-holder" style="display: block;">
                        <div class="coupon div_coupon" v-if="!showDiscount">
                            <div class="form-group field-couponCode">
                                <input v-model="cartCouponCode"
                                       class="checkout__input"
                                       id="couponCode"
                                       type="text"
                                       name="couponCode"
                                >
                                <div class="help-block">{{ textCodeNotFound }}</div>
                            </div>
                        </div>
                        <a href="javascript:;" class="btn apply_btn_discopunt" id="applyDiscountBtn"
                           v-if="!showDiscount" @click="applyDiscount">{{ Lang.get('js.apply_discount') }}</a>

                        <div class="shopping-cart__sum padding_top_15" v-if="!showDiscount">
                            <span class="shopping-cart__sum_title">{{ Lang.get('js.total') }}:</span>
                            <div class="shopping-cart__sum_wrap">
                                <span class="shopping-cart__sum_price">{{ currencyTotalPrice }}</span>
                            </div>
                        </div>

                        <div class="shopping-cart__wrapper" v-if="showDiscount">
                            <div class="shopping-cart__sum">
                                <span class="shopping-cart__sum_title">{{ Lang.get('js.items') }}:</span>
                                <div class="shopping-cart__sum_wrap">
                                    <span class="shopping-cart__sum_price shopping-cart__sum_through">{{
                                            currencyTotalPriceWithoutConditions
                                        }}</span>
                                </div>
                            </div>

                            <div class="shopping-cart__sum_discount-holder">
                                <div class="shopping-cart__sum">
                                    <div class="shopping-cart__sum_discount">
                                        {{ discountTitle }}
                                        <span class="shopping-cart__sum_price">{{ currencyDiscountPrice }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="shopping-cart__sum">
                                <span class="shopping-cart__sum_title">{{ Lang.get('js.total') }}:</span>
                                <div class="shopping-cart__sum_wrap" v-if="!totalLoading">
                                    <span class="shopping-cart__sum_price">{{ currencyTotalPrice }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="shopping-cart__checkout">
                        <div class="shopping-cart__buttons">
                            <a href="/" class="shopping-cart__btn-continue">{{ Lang.get('js.continue_shopping') }}</a>
                            <a href="#" class="btn" @click.prevent="checkout">{{ Lang.get('js.checkout') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="blocker" v-if="loading">
            <moon-loader :loading="loading" size="80px" color="#fff"></moon-loader>
        </div>
        <!--        <div class="coupon">-->
        <!--            <p>{{ Lang.get('js.coupon_code') }}</p>-->
        <!--            <div>-->
        <!--                <div>-->
        <!--                    <input type="text" class="form-control" :placeholder="Lang.get('js.coupon_code')">-->
        <!--                </div>-->
        <!--                <div>-->
        <!--                    <button class="btn">{{ Lang.get('js.apply_discount') }}</button>-->
        <!--                </div>-->
        <!--                <div>-->
        <!--                    {{ Lang.get('js.total') }}:<span>{{ currencyTotalPrice }}</span>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import VueNumberInput from '@chenfengyuan/vue-number-input'
import MoonLoader from 'vue-spinner/src/MoonLoader'

// empty cart response
const emptyCartResponseCode = 205

export default {
    name: 'Cart',
    props: {
        cartDefault: {
            type: Object,
            required: true
        }
    },
    components: {
        MoonLoader,
        VueNumberInput
    },
    data() {
        return {
            items: [],
            bonusItems: [],
            shipping: [],
            selectedBonusItem: 1,
            selectedShipping: 0,
            deliveryInsuranceCost: '',
            deliveryInsurance: true,
            cartCouponCode: '',
            cartCoupon: '',
            totalPriceWithoutConditions: 0,
            totalPriceWithDiscount: 0,
            currencyTotalPriceWithoutConditions: '',
            currencyTotalPrice: 0,
            currencyDiscountPrice: 0,
            showDiscount: false,
            loading: false,
            totalLoading: false,
            discountTitle: '',
            textCodeNotFound: '',
            Lang
        }
    },
    computed: {
        showBonusItems() {
            return this.bonusItems.length > 0
        },
        totalPrice() {
            return this.totalPriceWithoutConditions - this.totalPriceWithDiscount
        }
    },
    methods: {
        changeQuantity(item) {
            let data = {
                id: item.id,
                quantity: item.quantity
            }

            axios.post('/cart/change-quantity', data).then(res => {
                if (res.status === emptyCartResponseCode) this.reloadPage()

                this.setCurrencyTotalPrice(res.data['currency_total_price'])
                this.setTotalPriceWithoutConditions(res.data['total_price_without_conditions'])
                this.setTotalPriceWithDiscount(res.data['total_price_with_discount'])
                this.setCurrencyTotalPriceWithoutConditions(res.data['currency_total_price_without_conditions'])
                this.setItemAttribute(res.data['item'], 'subtotal')

                if (res.data['currency_discount'] !== 0) {
                    this.setDiscountBlock(res.data['currency_discount'], res.data['coupon_title'])
                }

                this.$set(this, 'bonusItems', res.data.bonus_items)

            })
        },
        async changeShipping() {
            this.$set(this, 'totalLoading', true)
            await axios.post('/cart/shipping', { 'shipping': this.selectedShipping }).then(res => {
                if (res.status === emptyCartResponseCode) this.reloadPage()

                this.setTotalPriceWithoutConditions(res.data['total_price_without_conditions'])
                this.setTotalPriceWithDiscount(res.data['total_price_with_discount'])
                this.setCurrencyTotalPriceWithoutConditions(res.data['currency_total_price_without_conditions'])
                this.setCurrencyTotalPrice(res.data['currency_total_price'])

                setTimeout(() => {
                    this.$set(this, 'totalLoading', false)
                }, 1000)
            })
        },
        changeInsurance() {
            axios.post('/cart/insurance', { 'insurance': this.deliveryInsurance }).then(res => {
                if (res.status === emptyCartResponseCode) this.reloadPage()

                this.setTotalPriceWithoutConditions(res.data['total_price_without_conditions'])
                this.setTotalPriceWithDiscount(res.data['total_price_with_discount'])
                this.setCurrencyTotalPriceWithoutConditions(res.data['currency_total_price_without_conditions'])
                this.setCurrencyTotalPrice(res.data['currency_total_price'])
            })
        },
        setItemAttribute(newItem, key) {
            if (this.items[newItem['id']]) {
                this.items[newItem['id']][key] = newItem[key]
            }
        },
        setCurrencyTotalPrice(price) {
            this.$set(this, 'currencyTotalPrice', price)
        },
        setDiscountPrice(price) {
            this.$set(this, 'currencyDiscountPrice', price)
        },
        setShowDiscount(val) {
            this.$set(this, 'showDiscount', val)
        },
        setTotalPriceWithoutConditions(price) {
            this.$set(this, 'totalPriceWithoutConditions', price)
        },
        setTotalPriceWithDiscount(price) {
            this.$set(this, 'totalPriceWithDiscount', price)
        },
        setCurrencyTotalPriceWithoutConditions(price) {
            this.$set(this, 'currencyTotalPriceWithoutConditions', price)
        },
        removeItem(itemId) {
            axios.post('/cart/remove/' + itemId).then(res => {
                this.reloadPage()
            })
        },
        setDefaultData() {
            this.$set(this, 'items', this.cartDefault['items'])
            this.$set(this, 'shipping', this.cartDefault['shipping'])
            this.$set(this, 'deliveryInsuranceCost', this.cartDefault['delivery_insurance_cost'])
            this.$set(this, 'bonusItems', this.cartDefault['bonus_packs'])
            this.$set(this, 'discountTitle', this.cartDefault['coupon_title'])
            this.$set(this, 'currencyDiscountPrice', this.cartDefault['currency_discount'])
            this.$set(this, 'showDiscount', (this.currencyDiscountPrice !== 0))
            this.$set(this, 'selectedShipping', this.cartDefault['selected_shipping'])
            this.$set(this, 'deliveryInsurance', this.cartDefault['delivery_insurance'])

            if (this.cartDefault.bonus_item !== null) {
                const bonusItem = (this.cartDefault.bonus_item.pack_id === null) ? 0 :
                    this.cartDefault.bonus_packs.findIndex(item => item.pack_id === this.cartDefault.bonus_item.pack_id)
                this.$set(this, 'selectedBonusItem', bonusItem)
            }

            this.setCurrencyTotalPrice(this.cartDefault['currency_total_price'])
            this.setTotalPriceWithoutConditions(this.cartDefault['total_price_without_conditions'])
            this.setTotalPriceWithDiscount(this.cartDefault['total_price_with_discount'])
            this.setCurrencyTotalPriceWithoutConditions(this.cartDefault['currency_total_price_without_conditions'])
            this.setDiscountPrice(this.cartDefault['currency_discount'])
            this.changeInsurance()
        },
        setBonusItem() {
            axios.post('/cart/bonus-item', this.bonusItems[this.selectedBonusItem]).then(res => {
                if (res.status === emptyCartResponseCode) this.reloadPage()

            })
        },
        checkout() {
            this.startLoading()
            axios.post('/cart/checkout').then(res => {
                if (res.status === emptyCartResponseCode) this.reloadPage()

                if (_.has(res, 'data.link')) {
                    window.location = res.data.link
                }
            })
        },
        applyDiscount() {
            axios.post('/cart/apply-discount', { 'couponCode': this.cartCouponCode }).then(res => {

                if (res.status === emptyCartResponseCode) this.reloadPage()

                this.setCurrencyTotalPrice(res.data['currency_total_price'])
                this.setTotalPriceWithoutConditions(res.data['total_price_without_conditions'])
                this.setTotalPriceWithDiscount(this.cartDefault['total_price_with_discount'])
                this.setCurrencyTotalPriceWithoutConditions(res.data['currency_total_price_without_conditions'])
                this.setDiscountBlock(res.data['currency_discount'], res.data['coupon_title'])

            }).catch(error => {
                if (error.response.status === 422) {
                    this.$set(this, 'textCodeNotFound', Lang.get('js.coupon_not_found'))
                }
            })
        },
        startLoading() {
            this.loading = true
        },
        stopLoading() {
            this.loading = false
        },
        reloadPage() {
            window.location.reload()
        },
        setDiscountBlock(value, code) {
            this.$set(this, 'discountTitle', code)
            this.setDiscountPrice(value)
            this.setShowDiscount(true)
        }
    },
    mounted() {
        this.setDefaultData()
        if (this.showBonusItems) {
            setTimeout(() => {
                this.setBonusItem()
            }, 100)
        }
    },
    watch: {
        bonusItems(val) {
            if (val.length){
                this.setBonusItem()
            }
        },
        selectedShipping() {
            setTimeout(async () => {
                await this.changeShipping()
            }, 60)
        },
        deliveryInsurance() {
            setTimeout(() => {
                this.changeInsurance()
            }, 80)
        }
    }
}
</script>

<style scoped>
.v-spinner {
    display: inline-block;
    vertical-align: middle;
}
</style>
